
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";
export const state = {
  authUser: null,
  message: new httpError(),

};

export const getters = {
  authUser: (state) => {
    return state.authUser;
  },
  IsAdmin: (state) => {
    return state.authUser && state.authUser.authLevel == "Admin"
  }
};

export const mutations = {
  SET_USER(state, data) {

    state.authUser = data;
  },
  REMOVE_USER(state) {
    state.authUser = null

  },
  setProgress(state, message) {
    state.message = message;
  },
};

export const actions = {
  async setAuthUser({ commit, dispatch }) {
    try {
      var auth = await HTTP.get("Impersonate/GetDealerAuthAsync")
      if (auth.data && auth.data.authLevel == "Admin") {
        commit('SET_USER', auth.data)
        return true
      } else {
        dispatch(
          "setMessage",
          new httpError({
            message: "Unauthorized Access",
            httpStatus: 500,
          })
        );
        return false
      }
    } catch (error) {
      dispatch('removeAuthUser')
      dispatch(
        "setMessage",
        new httpError({
          message: "Unauthorized Access",
          httpStatus: 500,
        })
      );
      return false
    }

  },
  removeAuthUser({ commit }) {
    commit("REMOVE_USER");
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
  addMFAToUser({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`/Auth/AddMFAToUser`, { email });
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'User enrolled in MFA',
            })
          );
          resolve('User enrolled in MFA');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 500,
              message: 'Request Failed: ' + err.message,
            })
          );
          reject(err.message);
        });
    });
  },
};
